import { Language } from '../types';

export const translations = {
  en: {
    // Navigation
    home: 'Home',
    journal: 'Journal',
    coach: 'Coach',
    challenges: 'Challenges',
    history: 'History',
    resources: 'Resources',
    settings: 'Settings',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    
    // Settings
    general: 'General',
    appearance: 'Appearance',
    accessibility: 'Accessibility',
    privacy: 'Privacy & Security',
    notifications: 'Notifications',
    data: 'Data & Backup',
    support: 'Support',
    donate: 'Support Us',
    
    // Language names
    language: 'Language',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Theme',
    dark: 'Dark',
    auto: 'Auto',
    recommended: 'Recommended',
    
    // Features
    soundEffects: 'Sound Effects',
    audioFeedback: 'Enable audio feedback',
    
    // Crisis Help
    crisisHelp: 'Crisis Help',
    emergencyContacts: 'Emergency Contacts',
    call988: 'Call 988',
    text988: 'Text 988',
    call911: 'Call 911',
    viewResources: 'View All Resources',
    
    // Wellness
    wellness: 'Wellness',
    mentalHealth: 'Mental Health',
    selfCare: 'Self Care',
    mindfulness: 'Mindfulness',
    meditation: 'Meditation',
    exercise: 'Exercise',
    nutrition: 'Nutrition',
    sleep: 'Sleep',
    social: 'Social',
    work: 'Work',
    family: 'Family',
    hobbies: 'Hobbies',
    
    // Progress
    progress: 'Progress',
    streak: 'Streak',
    level: 'Level',
    experience: 'Experience',
    achievements: 'Achievements',
    rewards: 'Rewards',
    
    // Messages
    welcome: 'Welcome',
    welcomeBack: 'Welcome Back',
    thankYou: 'Thank You',
    congratulations: 'Congratulations',
    goodJob: 'Good Job',
    keepGoing: 'Keep Going',
    youCanDoIt: 'You Can Do It',
  },
  
  es: {
    // Navigation
    home: 'Inicio',
    journal: 'Diario',
    coach: 'Entrenador',
    challenges: 'Desafíos',
    history: 'Historial',
    resources: 'Recursos',
    settings: 'Configuración',
    
    // Common
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    remove: 'Quitar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    
    // Settings
    general: 'General',
    appearance: 'Apariencia',
    accessibility: 'Accesibilidad',
    privacy: 'Privacidad y Seguridad',
    notifications: 'Notificaciones',
    data: 'Datos y Respaldo',
    support: 'Soporte',
    donate: 'Apóyanos',
    
    // Language names
    language: 'Idioma',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Tema',
    dark: 'Oscuro',
    auto: 'Automático',
    recommended: 'Recomendado',
    
    // Features
    soundEffects: 'Efectos de Sonido',
    audioFeedback: 'Habilitar retroalimentación de audio',
    
    // Crisis Help
    crisisHelp: 'Ayuda en Crisis',
    emergencyContacts: 'Contactos de Emergencia',
    call988: 'Llamar 988',
    text988: 'Enviar SMS 988',
    call911: 'Llamar 911',
    viewResources: 'Ver Todos los Recursos',
    
    // Wellness
    wellness: 'Bienestar',
    mentalHealth: 'Salud Mental',
    selfCare: 'Autocuidado',
    mindfulness: 'Atención Plena',
    meditation: 'Meditación',
    exercise: 'Ejercicio',
    nutrition: 'Nutrición',
    sleep: 'Sueño',
    social: 'Social',
    work: 'Trabajo',
    family: 'Familia',
    hobbies: 'Pasatiempos',
    
    // Progress
    progress: 'Progreso',
    streak: 'Racha',
    level: 'Nivel',
    experience: 'Experiencia',
    achievements: 'Logros',
    rewards: 'Recompensas',
    
    // Messages
    welcome: 'Bienvenido',
    welcomeBack: 'Bienvenido de Vuelta',
    thankYou: 'Gracias',
    congratulations: 'Felicitaciones',
    goodJob: 'Buen Trabajo',
    keepGoing: 'Sigue Adelante',
    youCanDoIt: 'Puedes Hacerlo',
  },
  
  fr: {
    // Navigation
    home: 'Accueil',
    journal: 'Journal',
    coach: 'Coach',
    challenges: 'Défis',
    history: 'Historique',
    resources: 'Ressources',
    settings: 'Paramètres',
    
    // Language names
    language: 'Langue',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Thème',
    dark: 'Sombre',
    auto: 'Automatique',
    recommended: 'Recommandé',
    
    // Crisis Help
    crisisHelp: 'Aide en Crise',
    emergencyContacts: 'Contacts d\'Urgence',
    call988: 'Appeler 988',
    text988: 'Envoyer SMS 988',
    call911: 'Appeler 911',
    viewResources: 'Voir Toutes les Ressources',
  },
  
  de: {
    // Navigation
    home: 'Startseite',
    journal: 'Tagebuch',
    coach: 'Coach',
    challenges: 'Herausforderungen',
    history: 'Verlauf',
    resources: 'Ressourcen',
    settings: 'Einstellungen',
    
    // Language names
    language: 'Sprache',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Design',
    dark: 'Dunkel',
    auto: 'Automatisch',
    recommended: 'Empfohlen',
    
    // Crisis Help
    crisisHelp: 'Krisenhilfe',
    emergencyContacts: 'Notfallkontakte',
    call988: '988 anrufen',
    text988: '988 SMS senden',
    call911: '911 anrufen',
    viewResources: 'Alle Ressourcen anzeigen',
  },
  
  ja: {
    // Navigation
    home: 'ホーム',
    journal: 'ジャーナル',
    coach: 'コーチ',
    challenges: 'チャレンジ',
    history: '履歴',
    resources: 'リソース',
    settings: '設定',
    
    // Language names
    language: '言語',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'テーマ',
    dark: 'ダーク',
    auto: '自動',
    recommended: '推奨',
    
    // Crisis Help
    crisisHelp: '危機的支援',
    emergencyContacts: '緊急連絡先',
    call988: '988に電話',
    text988: '988にSMS',
    call911: '911に電話',
    viewResources: 'すべてのリソースを表示',
  },
  
  zh: {
    // Navigation
    home: '首页',
    journal: '日记',
    coach: '教练',
    challenges: '挑战',
    history: '历史',
    resources: '资源',
    settings: '设置',
    
    // Language names
    language: '语言',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: '主题',
    dark: '深色',
    auto: '自动',
    recommended: '推荐',
    
    // Crisis Help
    crisisHelp: '危机帮助',
    emergencyContacts: '紧急联系人',
    call988: '拨打988',
    text988: '发送988短信',
    call911: '拨打911',
    viewResources: '查看所有资源',
  },
  
  ar: {
    // Navigation
    home: 'الرئيسية',
    journal: 'المذكرة',
    coach: 'المدرب',
    challenges: 'التحديات',
    history: 'التاريخ',
    resources: 'الموارد',
    settings: 'الإعدادات',
    
    // Language names
    language: 'اللغة',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'المظهر',
    dark: 'داكن',
    auto: 'تلقائي',
    recommended: 'موصى به',
    
    // Crisis Help
    crisisHelp: 'مساعدة الأزمات',
    emergencyContacts: 'جهات الاتصال الطارئة',
    call988: 'اتصل بـ 988',
    text988: 'أرسل رسالة 988',
    call911: 'اتصل بـ 911',
    viewResources: 'عرض جميع الموارد',
  },
  
  hi: {
    // Navigation
    home: 'होम',
    journal: 'जर्नल',
    coach: 'कोच',
    challenges: 'चुनौतियां',
    history: 'इतिहास',
    resources: 'संसाधन',
    settings: 'सेटिंग्स',
    
    // Language names
    language: 'भाषा',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'थीम',
    dark: 'डार्क',
    auto: 'ऑटो',
    recommended: 'अनुशंसित',
    
    // Crisis Help
    crisisHelp: 'संकट सहायता',
    emergencyContacts: 'आपातकालीन संपर्क',
    call988: '988 पर कॉल करें',
    text988: '988 को टेक्स्ट करें',
    call911: '911 पर कॉल करें',
    viewResources: 'सभी संसाधन देखें',
  },
  
  pt: {
    // Navigation
    home: 'Início',
    journal: 'Diário',
    coach: 'Coach',
    challenges: 'Desafios',
    history: 'Histórico',
    resources: 'Recursos',
    settings: 'Configurações',
    
    // Language names
    language: 'Idioma',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Tema',
    dark: 'Escuro',
    auto: 'Automático',
    recommended: 'Recomendado',
    
    // Crisis Help
    crisisHelp: 'Ajuda em Crise',
    emergencyContacts: 'Contatos de Emergência',
    call988: 'Ligar 988',
    text988: 'Enviar SMS 988',
    call911: 'Ligar 911',
    viewResources: 'Ver Todos os Recursos',
  },
  
  ru: {
    // Navigation
    home: 'Главная',
    journal: 'Дневник',
    coach: 'Тренер',
    challenges: 'Вызовы',
    history: 'История',
    resources: 'Ресурсы',
    settings: 'Настройки',
    
    // Language names
    language: 'Язык',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Тема',
    dark: 'Тёмная',
    auto: 'Авто',
    recommended: 'Рекомендуется',
    
    // Crisis Help
    crisisHelp: 'Кризисная Помощь',
    emergencyContacts: 'Экстренные Контакты',
    call988: 'Позвонить 988',
    text988: 'Отправить SMS 988',
    call911: 'Позвонить 911',
    viewResources: 'Посмотреть Все Ресурсы',
  },
  
  ko: {
    // Navigation
    home: '홈',
    journal: '일기',
    coach: '코치',
    challenges: '도전',
    history: '기록',
    resources: '리소스',
    settings: '설정',
    
    // Language names
    language: '언어',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: '테마',
    dark: '다크',
    auto: '자동',
    recommended: '권장',
    
    // Crisis Help
    crisisHelp: '위기 도움',
    emergencyContacts: '긴급 연락처',
    call988: '988 전화',
    text988: '988 문자',
    call911: '911 전화',
    viewResources: '모든 리소스 보기',
  },
  
  it: {
    // Navigation
    home: 'Home',
    journal: 'Diario',
    coach: 'Coach',
    challenges: 'Sfide',
    history: 'Cronologia',
    resources: 'Risorse',
    settings: 'Impostazioni',
    
    // Language names
    language: 'Lingua',
    english: 'English',
    spanish: 'Español',
    french: 'Français',
    german: 'Deutsch',
    japanese: '日本語',
    chinese: '中文',
    arabic: 'العربية',
    hindi: 'हिन्दी',
    portuguese: 'Português',
    russian: 'Русский',
    korean: '한국어',
    italian: 'Italiano',
    
    // Theme
    theme: 'Tema',
    dark: 'Scuro',
    auto: 'Automatico',
    recommended: 'Consigliato',
    
    // Crisis Help
    crisisHelp: 'Aiuto in Crisi',
    emergencyContacts: 'Contatti di Emergenza',
    call988: 'Chiama 988',
    text988: 'Invia SMS 988',
    call911: 'Chiama 911',
    viewResources: 'Visualizza Tutte le Risorse',
  }
};

export const t = (key: string, language: Language = 'en'): string => {
  const lang = translations[language] || translations.en;
  return (lang as any)[key] || key;
};

export const getLanguageName = (code: Language): string => {
  const languageNames: Record<Language, string> = {
    en: 'English',
    es: 'Español',
    fr: 'Français'
  };
  return languageNames[code] || code;
};

export const getLanguageFlag = (code: Language): string => {
  const flags: Record<Language, string> = {
    en: '🇺🇸',
    es: '🇪🇸',
    fr: '🇫🇷'
  };
  return flags[code] || '🌐';
}; 